<template>
	<div style="width: 100%; height: 85vh; overflow-y: auto">
		<school-users-table :element="adminOrganization" />
	</div>
</template>

<script>
import SchoolUsersTable from "@/modules/organization/form-component/school-users-table.vue"
import { mapActions, mapGetters } from "vuex"

export default {
	name: "User",
	components: { SchoolUsersTable },
	data() {
		return {
			heightscreen: window.innerHeight - 275
		}
	},
	computed: {
		...mapGetters({
			adminOrganization: "user/organization"
		})
	}
}
</script>
